import styled from 'styled-components/macro';

const Section = styled.div`
	background: #fff;
	padding: 20px;
`;

export default Section;
